import React, { Fragment, useEffect } from "react";
import { useForm, useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import "../../../scss/dashboard/abogadosForm.css";
import { Input, FormFeedback } from 'reactstrap';
import { Link, useHistory } from "react-router-dom";

const NAME_MAX_LENGTH = 45;
const DESCRIPTION_MAX_LENGTH = 95;

const EditBasicData = ({ onSubmit }) => {;
  const { t } = useTranslation();
  const {
    register,
    control,
    errors,
  } = useFormContext();
  const name = useWatch({
    name: 'name',
    control,
    defaultValue: ''
  })
  const description = useWatch({
    name: 'description',
    control,
    defaultValue: ''
  })

  return (
    <div className="abogados-form-datos">
      <h2 className="formAbogados-h2">Datos Basicos</h2>
      <label className="formAbogados--label">Nombre</label>
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "fit-content",
        }}
      >
        <Input
          className="formAbogados-1"
          name="name"
          maxLength={NAME_MAX_LENGTH}
          innerRef={register}
          invalid={!!errors?.name?.message}
        />
        
        <FormFeedback>{t(`errors.${errors?.name?.message}`)}</FormFeedback>
        <span
          style={{
            position: "absolute",
            right: "22%",
            top: ".2rem",
            fontFamily: "Inter",
            fontSize: ".8rem",
            color: "#9ea0a5",
          }}
        >
          {name.length}/{NAME_MAX_LENGTH}
        </span>
      </div>
      <label className="formAbogados--label">Descripción</label>
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "fit-content",
        }}
      >
        <Input
          type="textarea"
          className="formAbogados-2--1 "
          maxLength={DESCRIPTION_MAX_LENGTH}
          name="description"
          innerRef={register}
          invalid={!!errors?.description?.message}
        ></Input>
        <span
          style={{
            position: "absolute",
            right: "22%",
            bottom: ".6rem",
            fontFamily: "Inter",
            fontSize: ".8rem",
            color: "#9ea0a5",
          }}
        >
          {description.length}/{DESCRIPTION_MAX_LENGTH}
        </span>
      </div>
      <div>
        <label className="formAbogados--label mt-1 ml-4">
          <Input
            type="checkbox"
            className="formAbogadosConfig"
            name="active"
            innerRef={register}
          ></Input>
          Mostrar en catalogo
        </label>
      </div>
      <button
        type="submit"
        // disabled={!hasValues}
        onClick={onSubmit}
        className={"btn-accent-100 btn abogadosForm__button--1"}
      >
        Guardar
      </button>
    </div>
  );
};

export default EditBasicData;
